import { cn } from "@utils/tw"
import { createBlock, defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Side Rail",
  category: "layouts",
  icon: "align-left",
  tags: ["#subpage-layout"],
  flags: {
    sideRail: true,
  },
  transforms: {
    from: [
      {
        type: "block",
        blocks: ["core/heading"],
        isMatch(attrs) {
          return true
        },
        transform(attrs) {
          return createBlock("acf/page-page-siderail", {
            inline: {
              heading: attrs.content,
            },
            className: attrs.className,
          })
        },
      },
    ],
  },
  blockStyles: [
    {
      name: "lg",
      label: "Large",
    },
    {
      name: "md",
      label: "Medium",
      isDefault: true,
    },
    {
      name: "sm",
      label: "Small",
    },
    {
      name: "xs",
      label: "Extra Small",
    },
  ],
}

export default defineBlock("page/page-siderail", (props) => {
  if (env.admin) {
    return (
      <div>
        <EditableText
          store="heading"
          as="h2"
          placeholder="Enter a heading"
          className={cn(`wp-block-heading !mt-0`, "is-style-" + props.blockStyle)}
          plainText
          appendOnEnter={"core/paragraph"}
        />
        <InnerBlocks
          allowedBlocks={["core/paragraph", "content/button-row", "content/icons-row", "content/logos"]}
          appender={{ type: "simple" }}
        />
      </div>
    )
  } else {
    return (
      <div className="mt-8 pointer-events-none">
        <div className="md:absolute w-full">
          <div className="grid-auto">
            <div className="col-span-12 sm:col-2-8 md:col-span-4 pointer-events-auto">
              <EditableText
                store="heading"
                as="h2"
                className={cn(`wp-block-heading !mt-0 text-balance`, "is-style-" + props.blockStyle)}
              />
              <InnerBlocks />
            </div>
          </div>
        </div>
      </div>
    )
  }
})
